import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { RelatiesService } from 'src/app/shared/dataservices/relaties.service';
import { ToastrService } from 'ngx-toastr';
import { ObjectenService } from 'src/app/shared/dataservices/objecten.service';
import { ObjectSelect } from 'src/app/shared/model/models';
// import { ThrowStmt } from '@angular/compiler';
import { FactuurObject, FactuurSelect } from 'src/app/shared/model/factuur';
import { FactuurService } from 'src/app/shared/dataservices/factuur.service';
import { GeneralFunctionsService } from 'src/app/shared/general-functions.service';


@Component({
  selector: 'app-factuur-filter',
  templateUrl: './factuur-filter.component.html',
  styleUrls: ['./factuur-filter.component.less']
})
export class FactuurFilterComponent implements OnInit {



  @Output() selectionChanged = new EventEmitter< Array<FactuurObject>>();

  objectNR: string = '';
  factuurNR: string = '';
  objecten: Array<FactuurObject>
  objectenFilter :  Array<FactuurObject>


  constructor(private factuurService: FactuurService,
              private functions: GeneralFunctionsService,
              private toastr: ToastrService) { }

  ngOnInit() {
    this.factuurService.getObjecten(true).subscribe(list=>
      {
        this.objecten = list
        const data = localStorage.getItem("factuurfilter");
        if (data) {
          const os = JSON.parse(data) as FactuurSelect;
          this.factuurNR = os.factuurNR;
          this.objectNR = os.objectNR;
        } else {
          this.objectenFilter = this.objecten;
        }
        this.doFilter();
      });
  }


  doFilter() {
    //store for future use
    let oselect = new FactuurSelect();
    oselect.factuurNR = this.factuurNR;
    oselect.objectNR = this.objectNR;
    localStorage.setItem("factuurfilter",JSON.stringify(oselect));
    let data = {}
    if (this.objectNR !== undefined && this.objectNR != "")
      data["objectnr"] =  this.objectNR;
      if (this.factuurNR !== undefined && this.factuurNR != "")
        data["factuurnr"] = this.factuurNR;
    this.factuurService.getObjectenFilter(data).subscribe(list=> {
      this.objectenFilter = list;
      this.selectionChanged.emit(this.objectenFilter)

    }
    )

    // this.objectenFilter = this.objecten.filter( data => {
    //   let filter = true;
    //   if (oselect.objectNR != null) {
    //     filter = data.ObjectNummer.toString().startsWith(oselect.objectNR)
    //   }
    //   if (oselect.factuurNR != null) {
    //     filter = filter && data.ID.toString().startsWith(oselect.factuurNR)
    //   }
    //   return  filter;
    // })
  }

  notifyFactuurFilter() :boolean {
    console.log( this.factuurNR == '' && this.objectNR == '')
    return true ; // this.factuurNR == '' && this.objectNR == '';
  }

  doClear() {
    const oselect = new FactuurSelect();
    oselect.factuurNR = this.factuurNR;
    oselect.objectNR = this.objectNR;
    this.factuurNR = null;
    this.objectNR = null;
    localStorage.setItem("factuurfilter",JSON.stringify(oselect));
    this.objectenFilter = this.objecten;
    this.selectionChanged.emit(this.objectenFilter)
  }


}
